import { ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";

interface TooltipProps {
  children: ReactNode;
  message: ReactNode;
  position?: "top" | "bottom" | "left" | "right";
  className?: string;
}

const Tooltip = ({
  children,
  className,
  message,
  position = "top",
}: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const positions = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  if (!message) return children;

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => {
        setIsVisible(true);
      }}
      onMouseLeave={() => {
        setIsVisible(false);
      }}
    >
      {children}
      {isVisible && (
        <div
          className={twMerge(
            `
            absolute ${positions[position]}
            px-2 py-1 text-sm text-white
            bg-gray-800 rounded-md whitespace-nowrap
            z-50
          `,
            className
          )}
        >
          {message}
          <div className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
